import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { UserService } from 'app/core/user/user.service';
import { User } from 'app/core/user/user.types';
import { RoleService } from 'app/services/role.service';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate {
  user: User;

  constructor(private _userService: UserService, public router: Router, private roleService: RoleService) { }

  canActivate(route: ActivatedRouteSnapshot): boolean{
    return this.isAuthorized(route);
  }

  private isAuthorized(route: ActivatedRouteSnapshot): boolean {
    this._userService.user$
            .subscribe((user: User) => {
                this.user = user;
            });
    const roles = this.user.role_id;
    const title = route.data.title;
    const modules = this.roleService.getSelectedModules()?.filter(x => x.modules.nom == title) ?? [];

    if (modules.length === 0) {
        setTimeout(() => {
            window?.location.reload();
        }, 500);
        return false;
    }
    const expectedRoles = [];
    modules.forEach((module) => {
      if(!expectedRoles.includes(module.role_id)){
        expectedRoles.push(module.role_id);
      }
    });

    const roleMatches = expectedRoles.includes(roles);
    if(!roleMatches && this.router.url !== '/dossiers-interventions') {
        this.router.navigate(['dashboard']);
    }
    return roleMatches;
  }
}
